<template>
  <a-modal
      title="选择补抽品目"
      :visible="visible"
      :maskClosable="false"
      :width="1280"
      destroyOnClose
      @ok="onSave"
      okText="抽取"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <table class="fx-form-view" style="text-align: center">
      <tr>
        <th>品目名称</th>
        <th>品目代码</th>
        <th>区域限制</th>
        <th>需补抽人数</th>
        <th>补抽品目</th>
        <th>选择补抽品目</th>
      </tr>
      <tbody v-for="item in redrawExtractItem">
      <tr>
        <td>{{ item.fspmmc }}</td>
        <td>{{ item.fspmbm }}</td>
        <td>{{ item.extras && item.extras.areaAddressText }}</td>
        <td>{{ item.applyNum }}</td>
        <td>{{ item.redrawItemName }}</td>
        <th>
          <a-button type="primary" @click="onSelectItemChange(item)">选择</a-button>
        </th>
      </tr>
      </tbody>
    </table>
    <choose-redraw-purchase-item-v2 ref="items" :visible="purchaseVisible" @success="purchaseSuccess"
                                    :apply-id="applyId"
                                    @cancel="purchaseVisible=false"/>
  </a-modal>
</template>

<script>
import PurchaseForm from '@/epp/expertmain/selectexpertapply/common/itemform/PurchaseForm.vue'
import ChooseRedrawPurchaseItemV2 from '@/epp/expertmain/purchaseitems/ChooseRedrawPurchaseItemV2.vue'
import { RedrawExpert } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import { TipsMessage } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'

export default {
  name: 'PerRedrawExpertModal',
  components: { ChooseRedrawPurchaseItemV2, PurchaseForm },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    redrawExpertNum: {
      type: Number,
      default: 0
    },
    applyId: {
      type: String,
      default: undefined
    },
  },
  data () {
    return {
      redrawExtractItem: [],
      loading: false,
      purchaseVisible: false,
      purchaseForm: {
        data: []
      },
      itemId: undefined
    }
  },
  methods: {
    //初始化数据
    initData (result) {
      this.redrawExtractItem = result
    },
    //选择补抽的品目
    onSelectItemChange (item) {
      this.purchaseForm.data = []
      this.purchaseVisible = true
      this.itemId = item.id
      this.$refs.items.preView(this.purchaseForm.data,item)
    },
    purchaseSuccess (data) {
      this.purchaseVisible = false
      this.redrawExtractItem.map(item => {
        if (item.id === this.itemId) {
          item.redrawItemCode = data.map(item => item.fspmbm).join(',')
          item.redrawItemName = data.map(item => item.fspmmc).join(',')
        }
      })
      this.purchaseForm.data = []
      data.forEach(item => {
        let customJson = {
          'fid': item.fid,
          'fspmmc': item.fspmmc,
          'fspmbm': item.fspmbm,
        }
        this.purchaseForm.data.push(customJson)
      })
    },
    //回传输入的值
    onSave () {
      let that = this
      let extractItem = that.redrawExtractItem.filter(item => !!item.redrawItemCode)
      if (!extractItem) {
        TipsMessage(this, '$warning', '请至少选择一个补抽品目，再进行抽取!')
        return
      }
      let data = {
        applyId: that.applyId,
        expertItemList: [...extractItem]
      }
      that.doRedrawExpert(data)
    },
    async doRedrawExpert (data) {
      try {
        this.loading = true
        let res = await RedrawExpert(data)
        if (200 !== res.code) {
          TipsMessage(this, '$error', '补抽失败')
          return
        }
        this.purchaseForm = {
          data: []
        }
        this.$emit('success', res.result)
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
